export class VisibilitySelector {
	criterionKey;
	visibleOn;

	constructor(criterionKey, visibleOn) {
		this.criterionKey = criterionKey;
		this.visibleOn = visibleOn;
	}
}
